import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Accommodation } from '../../types';
import { AccommodationOptionsComponent } from '../accommodation-options/accommodation-options.component';
import { LabelComponent } from '@lx/quote-tool/lite/shared/ui/components';

@Component({
  standalone: true,
  selector: 'lx-accommodation-details',
  templateUrl: './accommodation-details.component.html',
  styleUrls: ['./accommodation-details.component.scss'],
  imports: [LabelComponent, AccommodationOptionsComponent, CommonModule],
})
export class AccommodationDetailsComponent {
  @Input() accommodation: Accommodation | undefined;
}
